export const faqItems = [
  {
    id: "faq-1",
    question: "How does the LAX airport transfer service work?",
    answer: "Once we receive your flight details, we greet you at the airport arrival gate with a sign bearing your name. Thanks to our flight tracking system, we provide seamless service even for early or delayed flights. Luggage assistance and door-to-door service are included.",
  },
  {
    id: "faq-2",
    question: "How far in advance should I book?",
    answer: "We recommend booking at least 24 hours in advance for airport transfers and 3-7 days in advance for city tours and special events. However, we also evaluate last-minute requests for emergency situations.",
  },
  {
    id: "faq-3",
    question: "Which areas do you serve?",
    answer: "We serve the entire Los Angeles metropolitan area. We provide transfers to Beverly Hills, Hollywood, Santa Monica, Downtown LA, Pasadena, Malibu, and Orange County. Special pricing is available for long-distance requests.",
  },
  {
    id: "faq-4",
    question: "What payment options are available?",
    answer: "We accept cash, credit cards, and digital payment options. Invoice-based payment is also available for corporate and business clients. Depending on the size of the booking, a deposit or full payment is collected in advance.",
  },
  {
    id: "faq-5",
    question: "Do you provide child seats and accommodate special needs?",
    answer: "Yes, child seats (infant, toddler, and booster) are provided free of charge when requested in advance. Please also mention any special needs such as disability access or pet transportation during the reservation.",
  },
  {
    id: "faq-6",
    question: "Can I customize the city tour itinerary?",
    answer: "Absolutely! In addition to our standard tours, we offer fully customizable private tour itineraries. Let us know the places you'd like to visit, your preferred timeline, and your special interests, and we'll plan a unique LA experience just for you.",
  },
  {
    id: "faq-7",
    question: "How much does a private driver or LAX transfer cost in Los Angeles?",
    answer: "Every trip is quoted individually based on distance, duration, and service type: airport transfers get a flat rate, tours and events are typically priced by the hour. Send your route through the booking form or WhatsApp at +1 (310) 926-5298 and you'll receive a free, no-obligation quote within the hour.",
  },
  {
    id: "faq-8",
    question: "Can I book from outside the United States before my trip?",
    answer: "Yes, most of our guests reserve their airport pickup before flying to Los Angeles. WhatsApp at +1 (310) 926-5298 works from anywhere in the world and in any time zone. Share your flight number and we'll track your arrival, so your driver is waiting even if the flight is early or delayed.",
  },
];